module.exports = __webpack_public_path__ + "img/trainings-375_new.0c9aa6cf.jpg";